import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import {
  deleteTransferJobAtom,
  updateTransferJobAtom,
} from '@/atoms/transfer-jobs';
import { useTransferStatus } from '@/hooks/use-transfer-status';
import { TransferJob } from '@/types/transfer-job';

interface TransferJobStatusUpdaterProps {
  jobId: string;
}

export function TransferJobStatusUpdater({
  jobId,
}: TransferJobStatusUpdaterProps) {
  const { t } = useTranslation();
  const [, updateJob] = useAtom(updateTransferJobAtom);
  const [, deleteJob] = useAtom(deleteTransferJobAtom);

  // Update job status when transfer status changes
  const handleStatusChange = (statusData: any) => {
    let newStatus: TransferJob['status'] = 'active';
    let error: string | undefined;

    switch (statusData.status) {
      case 'completed':
        newStatus = 'completed';
        break;
      case 'failed':
        newStatus = 'failed';
        error = statusData.error || t('errors.transferFailed');
        break;
      case 'active':
        newStatus = 'active';
        break;
      case 'pending':
        newStatus = 'pending';
        break;
    }

    updateJob({
      jobId,
      updates: {
        status: newStatus,
        ...(error && { error }),
      },
    });
  };

  // Use transfer status hook to monitor this job
  const { error } = useTransferStatus(jobId, {
    enabled: true,
    onStatusChange: handleStatusChange,
  });

  useEffect(() => {
    if (error) {
      deleteJob(jobId);
    }
  }, [error, deleteJob, jobId]);

  // This component doesn't render anything
  return null;
}
